module.exports = __webpack_public_path__ + "static/media/Alison Swenson Headshot_1743539028653.8bd4a6e4.jpeg";